<template lang="pug">
  .demonWrapper(v-bind:class="{ active:hide }")
    .demon
      img(src='/img/demon1.png')
    
</template>

<script>
export default {
  name: 'bottomDemons',
  props: {
    hide: Boolean
  },
  watch:{
    hide:function(){
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .demonWrapper{
    width:100%;
    height:600px;
    position:absolute;
    bottom:0;
    overflow:hidden;
    opacity:.1;
    z-index: -1;
    transition:height 2s;
    .demon{
      margin-left:-200px;
    }
  }
  .demonWrapper.active{
    height:550px;
  }
  @media(max-width:760px){
    .demonWrapper{
      display:none;
    }
  }
</style>
